import { jsx as r } from "react/jsx-runtime";
import p, { useContext as u } from "react";
import { withRipple as m } from "@rmwc/ripple";
import { createComponent as i, useClassNames as l, Tag as f } from "@rmwc/base";
const a = p.createContext(!1), d = (t) => u(a) || t || !1, C = m({
  surface: !1
})(
  i(
    function(e, o) {
      const { children: c, ...s } = e, n = l(e, ["mdc-touch-target-wrapper"]);
      return /* @__PURE__ */ r(f, { tag: "div", ...s, ref: o, className: n, children: /* @__PURE__ */ r(a.Provider, { value: !0, children: c }) });
    }
  )
);
export {
  C as TouchTargetWrapper,
  d as useIsWrappedTouchTarget
};
